import { SquarePenIcon, TrashIcon } from 'lucide-react';
import { User } from '@console/utils';
import { Popconfirm } from '@/components/Popconfirm';
import { useTranslation } from 'react-i18next';

export interface ActionsProps {
  user: User;
  onEdit: (user: User) => void;
  onDelete: (user: User) => void;
  isLoading?: boolean;
}

export function Actions({ user, onEdit, onDelete, isLoading }: ActionsProps) {
  const { t } = useTranslation();

  return (
    <div className="gap-2xs flex items-center">
      <Popconfirm
        onConfirm={() => onDelete(user)}
        title={t('users.table.deleteAction.title')}
        description={t('users.table.deleteAction.description')}
        variant="danger"
        confirmLabel={t('users.table.deleteAction.label')}
      >
        <button
          type="button"
          className="text-neutral-muted hover:text-error-default outline-neutral-subtle cursor-pointer rounded-full transition-all focus:outline-2 focus:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isLoading}
        >
          <TrashIcon size={16} />
        </button>
      </Popconfirm>
      <button
        type="button"
        className="text-neutral-muted hover:text-neutral-default outline-neutral-subtle cursor-pointer rounded-full transition-all focus:outline-2 focus:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        onClick={() => onEdit(user)}
        disabled={isLoading}
      >
        <SquarePenIcon size={16} />
      </button>
    </div>
  );
}
